import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/configurator'

export default {
  getCatalog() {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/catalog`)
  },
  getControlBox(curtains, requiresSig) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/control-box`, {
      curtains,
      requires_sig: requiresSig,
    })
  },
  save(offer) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/save`, offer)
  },
  getOffer(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
}
